import './loading.scss';

import { Preloader } from '~shared/ui';

export function Loading() {
	return (
		<div className="loading">
			<Preloader />
		</div>
	);
}
